<template>
    <div class="userList_page">
        <div class="filter_box">
            <el-form :model="filter" label-width="40px" :inline="true">
                <el-form-item label="账号">
                    <el-input v-model="filter.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="filter.real_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="filter.tel" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="filter.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchUser">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="userAddDialogVisible = true">新建</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="userList" :border="true" v-loading="table_loading">
            <el-table-column prop="username" label="账号"></el-table-column>
            <el-table-column prop="real_name" label="姓名"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column prop="tel" label="电话"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status==1? true:false" type="primary" disable-transitions>在职</el-tag>
                    <el-tag v-if="scope.row.status==2? true:false" type="warning" disable-transitions>离职</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" v-if="pageType=='teacher'||userInfo.is_superuser">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="deleteUserHandle(scope.row)" type="text" size="small">删除</el-button>
                    <el-button @click="setPwd(scope.row)" type="text" size="small">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="10"
            :current-page="currentPage"
            class="page_pagination"
            @next-click="handlePageChange"
            @prev-click="handlePageChange"
            @current-change="handlePageChange"
            >
        </el-pagination>
        <el-dialog
        title="添加用户"
        :visible.sync="userAddDialogVisible"
        width="30%"
        center>
            <el-form :model="userAdd" label-width="80px" :rules="userAddFormRules">
                <el-form-item label="账号" prop="username">
                    <el-input v-model="userAdd.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="userAdd.password" autocomplete="off" show-password></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="real_name">
                    <el-input v-model="userAdd.real_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="tel">
                    <el-input v-model="userAdd.tel" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="userAdd.email" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userAddDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="userAddHandle">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            pageType: null,
            userAddDialogVisible: false,
            userAdd: {
                username: '',
                password: '',
                real_name: '',
                email: '',
                tel: '',
            },
            filter: {
                username: null,
                real_name: null,
                email: null,
                tel: null
            },
            userList: [],
            total: null,
            currentPage: 1,
            table_loading: false,
            userAddFormRules: {
                username: [
                    {required: true, message: '请输入账号'}
                ],
                password: [
                    {required:true, message: '请输入密码'}
                ],
                real_name: [
                    {required:true, message: '请输入姓名'}
                ],
                tel: [
                    {required:true, message: '请输入电话'}
                ],
                email: [
                    {required:true, message: '请输入邮箱'}
                ]
            }
        }
    },
    mounted() {
        if (this.$route.fullPath=='/teacher') {
            this.pageType = 'teacher'
        } else if (this.$route.fullPath=='/admin') {
            this.pageType = 'admin'
        }      
        this.loadUserList()
    },
    methods:{
        loadUserList(page){
            this.table_loading = true
            let url = '/user/'
            let query_data = {}
            if (this.pageType == 'teacher') {
                query_data.identity=2
            } else if (this.pageType == 'admin') {
                query_data.identity=1
            }
            if (page) {
                query_data.page=page
            }
            this.$axios.get(url,{
                params: query_data
            })
            .then(res => {
                if (res.status === 1) {
                    this.userList = res.data
                    this.total = res.total
                }
            })
            this.table_loading = false
        },
        userAddHandle(){
            let url = '/user/'  // 管理员添加教师
            if (this.pageType == 'teacher') {
                this.userAdd.identity = 2
            } else if (this.pageType == 'admin') {
                this.userAdd.identity = 1
            }
            if (!this.userAdd.username){
                this.$message.error('账号不能为空')
                return false
            } else if (!this.userAdd.password) {
                this.$message.error('密码不能为空')
                return false
            } else if (!this.userAdd.real_name) {
                this.$message.error('姓名不能为空')
                return false
            } else if (!this.userAdd.tel) {
                this.$message.error('电话不能为空')
                return false
            } else if (!this.userAdd.email) {
                this.$message.error('邮箱不能为空')
                return false
            }
            this.$confirm('确认提交吗？')
            .then(() => {
                this.$axios.post(url, this.userAdd)
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('用户添加成功')
                        this.userList.push(res.data)
                    } else {
                        this.$message.error(res.msg)
                        return false
                    }
                })
                this.userAdd = {
                    username: '',
                    password: '',
                    real_name: '',
                    email: '',
                    tel: '',
                },
                this.userAddDialogVisible = false
            })
            .catch(res => {
                this.$message.info('已取消')
            })
            
        },
        resetData(){
            if (this.$route.fullPath=='/teacher') {
                this.pageType = 'teacher'
            } else if (this.$route.fullPath=='/admin') {
                this.pageType = 'admin'
            }
            this.loadUserList()
        },
        searchUser(){
            let url = '/user/?'
            for (let key in this.filter) {
                if (this.filter[key]) {
                    url += `${key}=${this.filter[key]}&`
                }
            }
            if (this.pageType == 'teacher') {
                url += 'identity=2'
            } else if (this.pageType == 'admin') {
                url += 'identity=1'
            }
            this.$axios.get(url)
            .then(res => {
                if (res.status === 1) {
                    this.userList = res.data
                }
            })
        },
        handleClick(row) {
            let userId = row.id
            if (this.pageType == 'teacher') {
                this.$router.push({path: '/teacher/' + userId})
            } else if (this.pageType == 'admin') {
                this.$router.push({path: '/admin/' + userId})
            }           
        },
        setPwd(row){
            let userId = row.id
            this.$confirm('确认重置密码？')
            .then(() => {
                this.$axios.post('/user/set_pwd/', {
                    user_id: userId
                })
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('重置密码成功')
                    }
                })
            })
            .catch((res) => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        handlePageChange(page){
            this.loadUserList(page)
        },
        deleteUserHandle(row){
            let userId = row.id
            this.$confirm('确认删除用户吗？')
            .then(() => {
                this.$axios.delete('/user/'+userId+'/')
                .then(res => {
                    if (res.status === 1) {
                        const index = this.userList.findIndex((value) => value.id == userId)
                        if (index != -1) {
                            this.userList.splice(index,1)
                        }
                        this.$message.success('删除成功')

                    } else{
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        }
    },
    watch: {
        $route:{
            handler:'resetData',
        }
    },
}
</script>
<style lang="less" scoped>
.userList_page{
    padding: 20px;
    .filter_box{
        margin: 10px 0 30px 0;
    }
    .page_pagination{
        text-align: center;
        margin-top: 50px;
    }
}
</style>